import { useReportWebVitals as nextUseReportWebVitals } from 'next/web-vitals';
import { useConfig, useRouter, useServices } from 'core/common/hooks';
import { createReportWebVitalsFn } from '../entities';
import { WebVitalsObservabilityRecorder } from '../services';

export const useReportWebVitals = () => {
  const router = useRouter();
  const { observabilitySystem } = useServices();
  const { webVitals } = useConfig();

  const reportWebVitalsCallback = createReportWebVitalsFn({
    config: webVitals,
    recorder: new WebVitalsObservabilityRecorder(observabilitySystem),
    pathname: router.asPath,
  });

  nextUseReportWebVitals(reportWebVitalsCallback);
};
